// Shared getServerSideProps helper for the search layout pages: resolves the
// NextAuth session and the user's favorites in one call, so every preset
// search page serves the same props contract as /Buscar. Lives outside
// src/pages/ (non-page files there leak into the filesystem-scanned sitemap).

import { getSession } from "next-auth/react";

import { getApiBaseUrl } from "@/config/config";

const fetchWithTimeout = async (url, options = {}, timeout = 5000) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    try {
        const response = await fetch(url, { ...options, signal: controller.signal });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error(`Error fetching ${url}:`, error.message);
        return null;
    } finally {
        clearTimeout(timeoutId);
    }
};

export async function getSessionAndFavorites(context) {
    const session = await getSession(context);
    const baseUrl = getApiBaseUrl();

    // The request is started unconditionally and awaited only when a
    // refreshable session exists — matches the long-standing page behavior
    // (anonymous SSR logs a 401 from this fire-and-forget request).
    const fetchFavorites = fetchWithTimeout(`${baseUrl}/user/getfavorites`, {
        method: "POST",
        body: JSON.stringify({ contact_id: session?.contact_id }),
        headers: {
            "Content-Type": "application/json",
            Authorization: session ? `Bearer ${session?.token}` : "",
        },
    });

    try {
        const favorites = await (session?.refreshToken ? fetchFavorites : Promise.resolve(null));
        return { session, favorites };
    } catch (error) {
        console.error("Error al obtener los datos:", error);
        return { session, favorites: [] };
    }
}
